import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex,
  cilNewspaper,
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl,
  cilArrowRight,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChart,
  cilChartPie,
  cilCheckAlt,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilColumns,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilFork,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cilHome,
  cilStorage,
  cilNoteAdd,
  cilHistory,
  cilBalanceScale,
  cilPlus,
  cilMinus,
  cilFingerprint,
  cilLowVision,
  cilTransfer,
  cilBarChart,
  cilTrash,
  cilSearch,
  cilChatBubble,
  cilBook,
} from "@coreui/icons";
import {
  help_icon,
  arrow_right,
  search,
  carret_down,
  anonymize,
  pencil,
  trash,
  bars,
  mail,
  password,
  xIcon,
} from "./help";

export const iconsSet = Object.assign(
  {},
  {
    help_icon,
    arrow_right,
    search,
    carret_down,
    anonymize,
    pencil,
    trash,
    bars,
    mail,
    password,
    xIcon,
  },
  {
    cilTrash,
    cilBook,
    cilChatBubble,
    cilSearch,
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChart,
    cilChartPie,
    cilCheckAlt,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilColumns,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilFork,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilNewspaper,
    cilHome,
    cilStorage,
    cilNoteAdd,
    cilHistory,
    cilBalanceScale,
    cilPlus,
    cilMinus,
    cilFingerprint,
    cilLowVision,
    cilTransfer,
    cilBarChart,
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl,
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex,
  }
);
